import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";

function TextSetting(props) {
  const [value, setValue] = React.useState(props.setting.value);
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <Grid container alignItems={"center"} spacing={1}>
              <Grid item xs={4}>
                <Typography>{props.label}</Typography>
              </Grid>
              <Grid item xs={8}>
                <TextField
                  variant={props.variant ? props.variant : "standard"}
                  inputProps={props.inputProps ? props.inputProps : ""}
                  helperText={props.helperText ? props.helperText : ""}
                  fullWidth
                  disabled={!write}
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  onBlur={() => {
                    props.onChange(value);
                  }}
                />
              </Grid>
            </Grid>
            {props.children}
          </>
        );
      }}
    />
  );
}

export default TextSetting;
